var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"readonly":_vm.readonly,"disabled":_vm.readonly},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }